import React from "react";
import './General.css';

class General extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">بوست شامل عن الحياة في ألمانيا للطلاب </legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        بوست لنادر رفعت Nader refaat 
                                        <br/>
                                        البوست ده عن اهم النقط اللى محتاج تعرفها فى المانيا من واقع خبرتي القصير
                                        <br/>
                                        <br/>
                                        1- الدراسه 
                                        <br/>
                                        ==========
                                        <br/>
                                        الدراسه عاده بتكون بنظام التيرمات فيه تيرم صيفي و تيرم شتوي الصيفي بيبدأ فيه ابريل و الشتوي في اكتوبر و عاده مش بيكون فيه وقت كبير بين انتهاء المحاضرات و الامتحانات فلازم تزاكر من الاول 
                                        <br/>
                                        الدراسه هنا بتعتمد على البحث فى المصادر المختلفه محدش هيبسطلك المعلومه و يحكيلهالك فصوره قصه بسيطه عشان تحفظها لازم تقرا نفس المعلومه من اكتر من مصدر عشان تفهمها كويس وده نظام صعب ولكن بيخليك تدرب على النظام البحثي و الاعتماد على مصادر اوليه و مراجع و العلم فصورته الاولى اللى هيا الابحاث 
                                        <br/>
                                        عاده نظام الشرح بيكون من البور بوينت و البور بوينت مش بيكون فيه كل حاجه مجرد عنواين تساعد المحاضر في تنظيم المحاضره مع بعض الرسومات للتوضيح لكن الشرح نفسه لازم حضرتك تكتب او تسجل ورا المحاضر و ترووح تقرا اكتر عن النقط ديه و تبلور العناصر الاساسيه فكل محاضره و تفهمها كويس و تعرف انت مطلوب منك ايه فالامتحان 
                                        <br/>
                                        لازم تعرف المصادر اللي المحاضر بيعتمد عليها لوضع المنهج لان ديه اللى هترجعلها في حاله انك عاوز تفهم نقطه اكتر او تشوف امثله اكتر 
                                        <br/>
                                        حاول تستخدم اليوتيوب هتلاقي فيديوهات ممتازه بتشرح حاجات صعب تتفهم من غير فيديو خصوصا الحاجت العلميه 
                                        <br/>
                                        دور على المنح و التدريبات عمليه و الكورسات المجانيه و قدم على interships هتفيدك جدا فالسي في بعدين
                                        <br/>
                                        <br/>
                                        2- السكن 
                                        <br/>
                                        ========
                                        <br/>
                                        افضل سكن طبعا سكن الطلبه لانه بوفرلك امكانيات كتيير و باسعار اقل من بره بس عموما السكن فحدود 200 يورو ل 350 للغرفه المفرده فيه شقه مكونه من غرفتين او اكثر لحد 6 غرف و في مواقع كتير ممكن تدور فيها على سكن ولكن ممكن تقابل مشكله انك متعرفش تحجز سكن الا لما توصل لان غالبا اصحاب السكن بيطلبو انهم يقابلوك قبل ما تعمل العقد 
                                        <br/>
                                        طيب ممكن تعمل ايه ؟ ممكن تحجز فهوستل و هي فنادق للشباب بتكون رخيصه تبتدي من 9 يورو للليله و بتكون غرف مشتركه طبعا ممكن تحجز من على النت بدون دفع اسبوع مثلا او اكتر لحد ما تلاقي سكن كويس مناسب تستقر فيه 
                                        <br/>
                                        <br/>
                                        الهوستل 
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='http://www.hostels.com/germany'>hostels.com/germany</a>
                                        </div>
                                        <br/>
                                        للبحث عن سكن 
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://deutschland-integration-ratgeber.blogspot.com/p/wohnu'>deutschland-integration-ratgeber.blogspot.com</a>
                                            <br/>
                                            <a target='_blank' rel='noreferrer' href='http://drferas.com/2012/05/07/housing-in-germany/'>drferas.com/2012/05/07/housing-in-germany</a>
                                        </div>
                                        <br/>
                                        3- المواصلات 
                                        <br/>
                                        ===========
                                        <br/>
                                        شبكه المواصلات في المانيا ممتازه و مترابطه جيدا و تعد الافضل على مستوي اوروبا 
                                        <br/>
                                        فيه انواع كتير منها الترام و الدويتش بان و الاس بان و المترو و الاوه بان 
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://deutschland-integration-ratgeber.blogspot.com/p/deutschebahn.html'>deutschland-integration-ratgeber.blogspot.com/p/deutschebahn.html</a>
                                            <p>_______________________</p>
                                            <a target='_blank' rel='noreferrer' href='https://deutschland-integration-ratgeber.blogspot.com/p/blog-page_29.html'>deutschland-integration-ratgeber.blogspot.com/p/blog-page_29.html</a>
                                        </div>
                                        طيب المهم بقي بالنسبه للمواصلات 
                                        <br/>
                                        كل ترام او اتوبيس ليه ميعاد لازم تعرفه عشان متطلعتش على المحطه و نفس المحطه بيعدي عليها كزا خط متنزلش تركب و خلاص شوف الرقم اللى انت هتركبه و بيجي الساعه كام بالزبط 
                                        <br/>
                                        و فيه اندرويد ابليكيشين ممكن تنزله بتكتب اسم المحطه اللى واقف فيها و اللى عاوز تروحها و هو بيقولك هتركب خط كام و هيجي امتى 
                                        <br/>
                                        اولا ما توصل لازم تروح الجامعه تطلع الكارنيه لان ده كارت موصلاتك المجانى فالمواصلات داخل المدينه و طبعا ده هياخد وقت فبطلع واحد مؤقت تركب بيه لحد ما الاساسي يطلع 
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.ryanair.com/gb/en/'>Ryanair</a> اخيرا فيه مواقع زي
                                        <br/>
                                        بيكون عليها رحلات طيران رخيصه جدا داخل اوروبا لو حابب تسافر بلد قريبه ممكن يوصل العرض ل 3 يورو بس طيران لحد لندن مثلا 
                                        <br/>
                                        بالنسبه للسفر الداخلى الدويتش بان طبعا ممتاز
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='http://www.bahn.com/i/view/GBR/en/'>bahn.com</a> و فيه عروض بتبقي عليه
                                        <br/>
                                        و الارخص الاتوبيس و فيه شركات كتير
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.flixbus.com/'>Flixbus</a> اسعارها كويسه جدا زي
                                        <br/>
                                        <br/>
                                        4- الاتصالات
                                        <br/>
                                        ==========
                                        <br/>
                                        فيه شركات كتير زي o2 and Vodafone de and aldi 
                                        <br/>
                                        ممكن تعمل عقد بسنه او اتنين او تشتري خط و تعمل باقه و بتبدي من 5 يورو فيه باقه كويسه ب 10 يورو بتديك 200 دقيقه او رساله و 500 ميجا انترنت و بعدها السرعه بتنزل و النت مش بيقف و فيه ب 30 يورو بتديك 3 جيجا و مكالمات مفتوحه داخل المانيا و الانترنت موجود فالجامعه و السكن الجامعي و بعض الاماكن بيكون فيها شبكات مفتوحه زي ماكدونالز
                                        <br/>
                                        <br/>
                                        5- الشراء
                                        <br/>
                                        ==========
                                        <br/>
                                        طبعا فيه محالات كتير بس اغلبها مش رخيص خصوصا انك لسا مش بتشتغل 
                                        <br/>
                                        الرخيص
                                        <br/>
                                        Primark 
                                        <br/>
                                        Kik
                                        <br/>
                                        C & A
                                        <br/>
                                        Woolworth 
                                        <br/>
                                        TK max
                                        <br/>
                                        بالنسبه للجزم و الكوتشي : Deichmann
                                        <br/>
                                        بالنسبه للادوات المكتبيه و اداوت المطبخ و الادوات المنزليه : <a target='_blank' rel='noreferrer' href='https://www.mac-geiz.de'>mac-geiz.de</a>
                                        <br/>
                                        euroshop و كمان 
                                        <br/>
                                        فيه اسواق اسبوعيه للخضروات و الفاكهه بتكون ارخص اعرف اماكنها و مواعيدها 
                                        <br/>
                                        فيه اسواق مستعمل ليها مواعيد اعرف برضو المواعيد و الاماكن 
                                        <br/>
                                        بالنسبه للشراء الاونلين
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://amazon.de'>amazon.de</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://ebay.de'>ebay.de</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.ebay-kleinanzeigen.de/'>ebay-kleinanzeigen.de</a>
                                        </div>
                                        <br/>
                                        ممكن تعمل prime account على amazon لمده سنه ببلاش و ده هيفيدك انه هيديلك عروض و خدمه توصيل اسرع مجانى و ممكن يديك رصيد فالاول ببلاش و لو دعيت حد بتاخد 15 يورو على كل شخص 
                                        <br/>
                                        هتحتاج تعمل كريدت كارد للشراء الاونلين لان كارت الدويتش بانك مش كريدت كارد 
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='http://www.almaniah.com/articles/view/173'>almaniah.com/articles/view/173</a>
                                        <br/>
                                        <br/>
                                        6- الاكل 
                                        <br/>
                                        ========
                                        <br/>
                                        قدامك حلين الاول مطعم الجامعه او MENSA بيقدم اطباق ممتازه و متنوعه و اسعارها ارخص من بره بكتيير فحدود يورو و نص لخمسه يورو 
                                        <br/>
                                        الحل الثاني هو الارخص انك تشتري من السوبر ماركت و المانيا فيها سلاسل ماركت كويسه و رخيصه و لكن احذر ليس كل الماركت رخيصه ………….الارخص و الاشهر Aldi – Leidl – Penny – Rewe
                                        <br/>
                                        بالنسبه للاكل الحلال موجود فيه الماركتات العربيه و التركيه فقط اسئل عنها
                                        <br/>
                                        <br/>
                                        7- الخدمات اللى الجامعه بتقدمها 
                                        <br/>
                                        =====================
                                        <br/>
                                        طبعا هيا خدمات كتير مثل قاعات للمذاكره الفرديه او الجماعيه و انترنت و خدمه تصوير و طباعه ارخص من بره بكتيير و مكتبات و معارض و متاحف و حاجات كتير 
                                        <br/>
                                        اتحاد الطلبه بيعمل عروض و رحلات و حفلات خصوصا فاول التيرم و خدمات وظايف 
                                        <br/>
                                        كذلك نوادي الطلبه بتعمل حفلات شهريه و رحلات تعرف على المدينه 
                                        <br/>
                                        فيه يوم من اول كل شهر بيكون دخول المتاحف مجانى لو حابب تتفرج او تتفسح
                                        <br/>
                                        <br/>
                                        8- فيه شويه حاجات لازم تعملها اول ما توصل 
                                        <br/>
                                        ============================
                                        <br/>
                                        - تسجل نفسك فالبلديه و تثبت محل اقامتك 
                                        <br/>
                                        - تعمل تامين صحي بيكون من 50 –80 - يورو فالشهر زاد دلوقتي و بيغطي كل التخصصات 
                                        <br/>
                                        - تفعل الحساب البنكي 
                                        <br/>
                                        - تشتري خط تلفون 
                                        <br/>
                                        - تروح تسجل نفسك فالجامعه 
                                        <br/>
                                        - تسجل نفسك في المواد اللى هتختارها 
                                        <br/>
                                        - لو فيه كورسات لغه تبع الجامعه سجل نفسك لو محتاج تقوي اللغه 
                                        <br/>
                                        - تقدم على الاقامه
                                        <br/>
                                        9- بعض المدن و يمكن كلها ممكن تقدم على حاجه اسمها welcome bonus 
                                        <br/>
                                        ده بيكون للطلبه و بتقدم عليه في البلديه و بيديك 150 يورو هديه بعدها بكام شهر
                                        <br/>
                                        <br/>
                                        10- نصائح عامه 
                                        <br/>
                                        ============
                                        <br/>
                                        - ممنوع تنزل تورنت و الا ستتعرض لغرامه كبيره جدا 
                                        <br/>
                                        - اعرف كيفيه فصل النفايات 
                                        <br/>
                                        - اعرف قوانين المرور و عبور الطريق 
                                        <br/>
                                        - فيه حاره على الرصيف للعجل متمشيش عليها 
                                        <br/>
                                        - ممكن تشترك في جيم بعقد سنوي ب 15 – 20 يورو فالشهر و فيه تخفيضات للطلبه 
                                        <br/>
                                        - الشنط و اكسسوار الموبيل و الكومبيوتر غالى جدا هنا اشتري من مصر ارخص 
                                        <br/>
                                        - العجل وسيله موصلات و رياضه جيده جدا و فيه مراكز صيانه باسعار رمزيه للطلبه 
                                        <br/>
                                        - فيه هيئات بتنظم رحلات للمدن القريبه سواء فى المانيا او خارجها باسعار رخيصه جدا رحلات لمده يوم او اتنين لو حابب تتعرف على المدن الاوروبيه 
                                        <br/>
                                        - اي مكان فى المانيا او مكتب او مبني ليه مواعيد و المواعيد هنا مش ثابته يوميا يعني فيه ايام بيقفلو بدري ساعتين مثلا او بيفتحو فى مواعيد معينه فلما تبقي رايح اي مكان اعرف مواعيده كويس 
                                        <br/>
                                        - اغلب المحلات بيقفل الساعه 8 و يوم الحد اجازه كل حاجه قافله فلازم تشتري حاجتك كلها قبل الاحد و قبل الساعه 8 
                                        <br/>
                                        - نام بدري عشان تصحي بدري و تستغل يومك لان لو صحيت متاخر هتلاقي كل حاجه قفلت او خلاص هتقفل و مش هتعمل اي مشاوير 
                                        <br/>
                                        - الالمانى مهم جدا لان فيه ورق كتير و جوابات كلها بالالمانى و كمان فيه اعلانات فالجامعه مهمه و فيه اماكن كتيير ميعرفوش انجليزي و فيه مواقع كتير مفهاش غير المانى 
                                        <br/>
                                        - ممكن تنزل google translate german offline package عشان تترجم لو معكش انترنت و فيه خاصيه الترجمه بالكاميرا بدل الكتابه 
                                        <br/>
                                        - نزل offline maps for google
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default General;
